import useAuthentication from '../../hooks/useAuthentication';
import { Navigate, useLocation } from 'react-router-dom';
import { UserPermissionType } from '../../Types/Authentication/AuthenticationTypes';
import moduleRoutes from '../../routes/moduleRouteList';
function PrivateRoute({ children, }: { children: JSX.Element,page?:keyof UserPermissionType }) {
    const {permissions,isAuthenticated} = useAuthentication();
    const location = useLocation();
    if(!isAuthenticated){
        return <Navigate to={`${moduleRoutes.root}${moduleRoutes.authentication}`} state={{ from: location }} replace />
    }
    if (permissions === null) {
        return <Navigate to={`${moduleRoutes.root}`} state={{ from: location }} replace />;
    }else{
        return children
    }
  
    
}

export default PrivateRoute
